import axios from "axios";
import { CLOCKS_BILLING_ITEMS, CLOCKS_ITEMS, CLOCK_ITEM, SET_ERROR, CLOCKS_SUMMARY } from '../../types';

export const billingItemsClocks = () => {
    return async dispatch => {
        await axios.get('/api/clock-items/clocks-billing-items').then(res => {
            dispatch({
                type: CLOCKS_BILLING_ITEMS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const getClockItems = () => {
    return async dispatch => {
        await axios.get('/api/clock-items/items').then(res => {
            dispatch({
                type: CLOCKS_ITEMS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const saveClockItem = payload => {
    return async dispatch => {
        await axios.post('/api/clock-items/add-update-clock', payload).then(res => {
            dispatch({
                type: CLOCK_ITEM,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const clocksSummary = () => {
    return async dispatch => {
        await axios.get('/api/clock-items/summary').then(res => {
            dispatch({
                type: CLOCKS_SUMMARY,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
}
